<header class="dash-toolbar" style="background-color: #00cec9;">
    <div>
      <h3 style="color: white;display: inline-block;text-transform:capitalize;" id="name">
        <span style="color:#cecbcb;" id="name">Welcome </span>
      </h3>
    </div>
  </header>

  <div class="row">
    <div class="col-3">
        <div
  class="dash-nav dash-nav"
  style="background-color: white; background: url('assets/bottom-img.png'),url('assets/worldmap.png');background-repeat: no-repeat;background-position:bottom,top;background-size:auto,cover;background-color: white"
>
  <header style="background: rgba(0, 0, 0, 0.495)">
   
    <div style="text-align: center;">
      
      <img src="../../../../assets/logo.png" style="height: 55px;" />
    </div>
  </header>
  <nav class="dash-nav-list" style="margin-top: 40px">
    <a
      routerLink="/mr"
      class="dash-nav-item"
      routerLinkActive="active"
    >
      <i class="fa fa-home"></i> Dashboard
    </a>
    <a
      routerLink="/mrappointment"
      class="dash-nav-item"
      routerLinkActive="active"
    >
      <i class="fa fa-calendar"></i> Appointments
    </a>
    <a
    (click)="onlogout()"
    class="dash-nav-item"
    routerLinkActive="active"
  >
    <i class="fa fa-calendar"></i> Logout
  </a>
  </nav>
  <div style="text-align: center;">
    <p
      style="color:white;font-size: 12px;word-wrap:break-word;text-align: center;position: absolute;bottom:1px;padding:5px">
      © Copyright <b>MAVIN GLOBUS</b><br />
      All Rights Reserved
    </p>
  </div>
</div>
    </div>
    <div class="col-9" style="margin-top: 7%;">
      <table class="table">
        <thead>
          <tr>
            <th scope="col">#</th>
            <th scope="col">Doctor Name</th>
            <th scope="col">Appointment Time </th>
            <th scope="col">Status</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let appt of appointments">
            <th scope="row" >1</th>
            <td>{{appt.doctorId.name}}</td>
            <td>{{ moment(appt.appointmentDate).format('MMMM DD YYYY')}}</td>
            <td>{{appt.appointmentStatus}}</td>
            <!-- {{ moment(sinapp?.appointmentDate).format('MMMM Do YYYY') }} -->
          </tr>
        </tbody>
      </table>
    </div>
  </div>
  